import { render, staticRenderFns } from "./WorkdaySettings.vue?vue&type=template&id=306bc128&scoped=true"
import script from "./WorkdaySettings.vue?vue&type=script&lang=js"
export * from "./WorkdaySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306bc128",
  null
  
)

export default component.exports